import { Component, ViewChildren, QueryList, ElementRef, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UigProductExportTypes, UigExportColumns } from './uig-export-products.models';
import { UigExportProductsService } from './uig-export-products.service';

@Component({
    selector: 'app-uig-export-products',
    templateUrl: './uig-export-products.component.html',
    styleUrls: ['./uig-export-products.component.scss'],
    standalone: false
})
export class UigExportProductsComponent implements OnInit {

  exportMode: string = 'export';

  selectedExportType: string = UigProductExportTypes[UigProductExportTypes.CSV];
  exportTypes: string[] = Object.values(UigProductExportTypes).filter(
    (value) => typeof value === 'string'
  ) as string[];
  exportColumns: string[] = Object.values(UigExportColumns).filter(
    (value) => typeof value === 'string'
  ) as string[];
  selectedExportColumns: string[] = Object.values(UigExportColumns).filter(
    (value) => typeof value === 'string'
  ) as string[];

  constructor(public modal: NgbActiveModal, public exportService: UigExportProductsService) {}

  ngOnInit(): void {}

  onSubmit() {
    this.exportService.setSelectedExportColumns(this.selectedExportColumns);
    this.modal.close(this.exportMode === 'print' ? 'print' : this.selectedExportType);
  }

  onCheckBoxChange(e) {
    let index = this.exportColumns.indexOf(e.target.value);
    if (e.target.checked) {
       this.selectedExportColumns[index] = e.target.value;
    } else {
      this.selectedExportColumns[index] = '';
    }
  }

  @ViewChildren('columncheckboxes') checkboxes: QueryList<ElementRef>;

 
  checkAllColumns() {
    this.selectedExportColumns = Object.values(UigExportColumns).filter(
      (value) => typeof value === 'string'
    ) as string[];
    this.exportService.setSelectedExportColumns(this.selectedExportColumns);
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = true;
    });
  }

  uncheckAllColumns() {
    this.selectedExportColumns.fill("");
    this.exportService.setSelectedExportColumns(this.selectedExportColumns);
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
  }

  
}
